<script setup lang="ts">
import Background from '../components/Background.vue';
</script>

<template>
  <main class="content">
    <Background />
    <h1>Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <router-link to="/" class="link">Go to Home</router-link>
  </main>
</template>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 80px 20px;
}
</style>
